import {
  MpkRequest as MpkRequestGenerated, PripomienkovanieConfigApi,
} from 'elegislativa-frontend-ts-axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import MpkRequest from '../../model/pracovnyKrok/MpkRequest';
import dateToString from '../../function/dateToString';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';

const mpkConfigClient = new PripomienkovanieConfigApi(apiConfiguration(elegislativaPrefixPath));

const map = (
  mpkRequest: MpkRequest,
): MpkRequestGenerated => ({
  skratene: mpkRequest.skratene,
  dovodSkratenia: mpkRequest.dovodSkratenia,
  durationDays: mpkRequest.durationDays || 0,
  startDate: mpkRequest.startDate ? dateToString(mpkRequest.startDate) : null,
  pripomienkovatelList: mpkRequest?.dalsiPripomienkovatelia?.map(pripomienkovatel => pripomienkovatel.uuid) || [],
});

// eslint-disable-next-line import/prefer-default-export
export const configMpk = async (
  type: string,
  year: number,
  index: number,
  mpkRequest: MpkRequest,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const mpkRequestGenerated = map(mpkRequest);
  const { status } = await mpkConfigClient.configMpk(
    type,
    year,
    index,
    mpkRequestGenerated,
    headers,
  );
  return {
    responseCode: status,
  };
};
